import * as React from 'react';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { setInnerHtml } from 'sos-common/js/utils/helpers';

export interface IMainBodyProps {}
export interface IMainBodyState extends FormSectionBaseState {}

export default class MainBody extends FormSectionBase<IMainBodyProps, IMainBodyState> {
  constructor(props: IMainBodyProps) {
    super(props);

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  public render() {
    const { isInEditMode } = this.context;
    return (
      <EpiserverProperty propertyName="MainBody" isInEditMode={isInEditMode} usingDangerouslySetInnerHTML={true}>
        <div dangerouslySetInnerHTML={setInnerHtml(this.findProperty('MainBody'))}></div>
      </EpiserverProperty>
    );
  }
}
